import API from '../../../helpers/request/api';

const api = () => new API();

const fetchUserCommunities = () => {
  const query = {
    query: `{
      user_communities {
        id
        agreed_terms
        permission
        is_muted
        community {
          id
          name
          use_terms
          enable_use_terms
          is_open
          updated_at
          auto_approval_post
          auto_approval_comment
          moderator_alias
        }
      }
    }`,
  };

  return api().get(query);
};

const fetchById = (communityId, showLoader = true) => {
  const query = {
    query: `{
      user_community(community_id: "${communityId}") {
        id
        agreed_terms
        permission
        is_muted
        theme
        is_active
        qty_post_bookmarks
        qty_not_read_notifications
        user {
          id
          name
          photo
        }
        community {
          id
          name
          description
          use_terms
          enable_use_terms
          is_open
          posts_to_moderate
          comments_to_moderate
          updated_at
          auto_approval_post
          auto_approval_comment
          moderator_alias
        }
      }
    }`,
  };

  return api().get(query, showLoader);
};

const acceptUseTerms = (communityId) => {
  const query = {
    query: `mutation acceptUseTerms {
      acceptUseTerms(input: {
        community_id: ${communityId}
      }) {
        community_user {
          id
          agreed_terms
          permission
          is_muted
          theme
          is_active
          qty_not_read_notifications
          user {
            id
            name
            photo
          }
          community {
            id
            name
            use_terms
            enable_use_terms
            is_open
            posts_to_moderate
            comments_to_moderate
            updated_at
            auto_approval_post
            auto_approval_comment
            moderator_alias
          }
        }
      }
    }`,
  };

  return api().get(query);
};

const changeUserTheme = ({ communityId, theme }) => {
  const query = {
    query: `mutation changeCommunityUserTheme {
      changeCommunityUserTheme(input: {
        community_id: ${communityId}
        theme: "${theme}"
      }) {
        community_user {
          id
          agreed_terms
          permission
          is_muted
          theme
          is_active
          qty_not_read_notifications
          qty_post_bookmarks
          user {
            id
            name
            photo
          }
          community {
            id
            name
            use_terms
            enable_use_terms
            is_open
            posts_to_moderate
            comments_to_moderate
            updated_at
            auto_approval_post
            auto_approval_comment
            moderator_alias
          }
        }
      }
    }`,
  };

  return api().get(query);
};

export default {
  acceptUseTerms,
  fetchUserCommunities,
  fetchById,
  changeUserTheme,
};



// WEBPACK FOOTER //
// ./src/screens/Community/queries/community.js